import { useManuale } from '@/manuale/ManualeProvider';
import { manuale as manualeTesti } from '@/testi/manuale';
import { TabPanel, Tabs, HelpButton } from '@aulaviva/ui';
import { useSearchParams } from 'react-router';
import { amministrazione } from '@/testi';
import { IntestazioneAdmin } from './comuni';
import { SchedaCancellazioni } from './impostazioni/Cancellazioni';
import { SchedaContatti } from './impostazioni/Contatti';
import { SchedaEmail } from './impostazioni/Email';
import { SchedaRegistro } from './impostazioni/Registro';
import { SchedaRetention } from './impostazioni/Retention';

export function Impostazioni() {
  const t = amministrazione;
  const [params, setParams] = useSearchParams();
  const scheda = params.get('scheda') ?? 'contatti';
  const manualeCtx = useManuale();
  return (
    <>
      <IntestazioneAdmin titolo={t.titolo} sottotitolo={t.sottotitolo} />
      <Tabs
        ariaLabel={t.titolo}
        value={scheda}
        onValueChange={(v) => setParams({ scheda: v }, { replace: true })}
        aiuto={<HelpButton variant="compatto" label={manualeTesti.apri} onClick={() => manualeCtx.apri()} />}
        items={[
          { value: 'contatti', label: t.schede.contatti },
          { value: 'retention', label: t.schede.retention },
          { value: 'email', label: t.schede.email },
          { value: 'registro', label: t.schede.registro },
          { value: 'cancellazioni', label: t.schede.cancellazioni },
        ]}
      >
        <TabPanel value="contatti">{scheda === 'contatti' && <SchedaContatti />}</TabPanel>
        <TabPanel value="retention">{scheda === 'retention' && <SchedaRetention />}</TabPanel>
        <TabPanel value="email">{scheda === 'email' && <SchedaEmail />}</TabPanel>
        <TabPanel value="registro">{scheda === 'registro' && <SchedaRegistro />}</TabPanel>
        <TabPanel value="cancellazioni">{scheda === 'cancellazioni' && <SchedaCancellazioni />}</TabPanel>
      </Tabs>
    </>
  );
}
